import { AcquisitionSourceDTO, ApiSuccess } from '@superlekcja/shared'
import { api } from '@/services/api'

/*
  Zrodlo pozyskania (TASK-101.2): parametry kampanii z PIERWSZEGO wejscia trafiaja do profilu
  nowego konta, zeby retencje per zrodlo policzyc z bazy.

  Przechowujemy je w localStorage, nie w sessionStorage: link potwierdzajacy rejestracje mailem
  otwiera nowa karte. Zapis dzieje sie ZAWSZE, takze bez zgody na cookies — swiadoma decyzja
  wlasciciela (2026-10-05), opisana w polityce prywatnosci.

  Do backendu idzie po zalogowaniu, a nie w metadanych rejestracji (jak invitedBy), bo logowanie
  przez Google metadanych nie przenosi. O tym, czy konto jest nowe i czy ma juz zrodlo, decyduje
  backend — klient tylko dostarcza to, co zobaczyl.
*/

const STORAGE_KEY = 'superlekcja.acquisition'
const CAMPAIGN_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'] as const

function readStored(): AcquisitionSourceDTO | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

function externalReferrerHost(): string | undefined {
  try {
    const host = new URL(document.referrer).host
    return host && host !== window.location.host ? host : undefined
  } catch {
    return undefined
  }
}

/** Wolane raz na starcie aplikacji. Pierwsze wejscie wygrywa: kolejne reklamy go nie nadpisuja. */
export function captureAcquisitionFromUrl(): void {
  if (readStored()) return
  const params = new URLSearchParams(window.location.search)
  const campaign = Object.fromEntries(
    CAMPAIGN_PARAMS.flatMap(name => {
      const value = params.get(name)
      return value ? [[name, value]] : []
    })
  )
  // Wejscie bez parametrow kampanii nie jest zrodlem — konto zostanie z pustym `acquisition`.
  if (Object.keys(campaign).length === 0) return

  const source: AcquisitionSourceDTO = {
    ...campaign,
    referrer_host: externalReferrerHost(),
    landing_path: window.location.pathname,
    captured_at: new Date().toISOString(),
  }
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(source))
  } catch {
    // Brak storage (tryb prywatny) = brak zrodla; aplikacja dziala dalej.
  }
}

let sending = false

/** Wolane po zalogowaniu. Po odpowiedzi backendu zrodlo znika z przegladarki — niezaleznie od werdyktu. */
export async function sendPendingAcquisition(): Promise<void> {
  const source = readStored()
  if (!source || sending) return
  sending = true
  try {
    await api.post<ApiSuccess<{ recorded: boolean }>>('/profile/acquisition', source)
    localStorage.removeItem(STORAGE_KEY)
  } finally {
    sending = false
  }
}
